<template>
	<v-sheet rounded>
		<v-card outlined color="#F9F9FB">
			<v-card-title class="align-center">
				<v-icon left large color="#d26e4b">mdi-chart-arc</v-icon>
				<h3 class="grey--text text--darken-3">{{ title }}</h3>
				<v-spacer />
				<slot />
			</v-card-title>

			<v-divider class="thick" />

			<v-data-table
				v-model="selected"
				:headers="tableHeaders"
				:items="reports"
				:loading="loading"
				:search="searchReports"
				show-select
				disable-pagination
				hide-default-footer
				class="table-stripped">
				<template #top>
					<v-toolbar flat>
						<!--						<v-menu-->
						<!--							offset-x-->
						<!--							close-on-click-->
						<!--							close-on-content-click-->
						<!--							origin="center center"-->
						<!--							transition="slide-x-transition">-->
						<!--							<template #activator="{ on, attrs }">-->
						<!--								<v-btn-->
						<!--									color="primary"-->
						<!--									elevation="0"-->
						<!--									x-small-->
						<!--									:disabled="! length(selected)"-->
						<!--									class="mr-2"-->
						<!--									v-bind="attrs"-->
						<!--									v-on="on">-->
						<!--									{{ length(selected) }} Selected-->
						<!--									<v-icon right>mdi-chevron-down</v-icon>-->
						<!--								</v-btn>-->
						<!--							</template>-->

						<!--							<v-list dense>-->
						<!--								<v-list-item href="#">-->
						<!--									<v-list-item-title>Email Reports</v-list-item-title>-->
						<!--								</v-list-item>-->
						<!--								<v-list-item href="#">-->
						<!--									<v-list-item-title>Email Reports &amp; Invoice</v-list-item-title>-->
						<!--								</v-list-item>-->
						<!--							</v-list>-->
						<!--						</v-menu>-->
						<delete-button
							:x-small="true"
							:classes="'pl-1 pr-1'"
							:disabled="! length(selected)"
							model="reports"
							:model-ids="selected"
							@deleted="selected = []">
							<v-icon>mdi-delete-forever</v-icon> <span v-if="length(selected)">({{ length(selected) }})</span>
						</delete-button>
						<v-spacer />
						<div class="flex-fill datatable-filter-large">
							<v-text-field
								v-model="searchReports"
								class="table-search"
								append-icon="mdi-magnify"
								placeholder="Search..."
								name="searchReports"
								autocomplete="off"
								single-line
								clearable
								filled
								outlined
								dense
								full-width
								hide-details />
						</div>
						<div class="ml-3">
							<v-chip>{{ length(reports) | numeric }}</v-chip>
						</div>
					</v-toolbar>
				</template>

				<template #item.full_address="{ item }">
					<div v-if="item.properties.length !== 0">
						<div v-if="item.properties.length > 1">
							<ul class="table-address-list">
								<li v-for="property in item.properties" :key="property.id">
									{{ property.address_1 | capitalize }}
								</li>
							</ul>
						</div>
						<div v-else>
							{{ item.properties[0].address_1 | capitalize }}
						</div>
					</div>
					<div v-else><em class="red--text">Related property deleted. Delete this report.</em></div>
				</template>

				<template #item.asset_relationship="{ item }">
					<div v-if="item.properties.length !== 0">
						{{ item.properties[0].asset_relationship | capitalize }}
					</div>
					<div v-else><em class="red--text">Related property deleted. Delete this report.</em></div>
				</template>

				<template #item.type="{ item }">
					{{ item.type.report_type }}
				</template>

				<template #item.status="{ item }" :class="item.status.color">
					<td :class="item.status.color" class="status text-center">
						<v-edit-dialog
							persistent
							large
							:return-value.sync="item.status"
							@save="updateStatus(item)">
							<span class="status text--darken-4" :class="item.status.color.split(' ')[0] + '--text'">{{ item.status.name }}</span>
							<template #input>
								<v-autocomplete
									v-model="item.status"
									:items="statuses"
									item-text="name"
									return-object
									hide-details
									placeholder="Select Status"
									single-line />
							</template>
						</v-edit-dialog>
					</td>
				</template>

				<template #item.actions="{ item }">
					<td class="action-button">
						<Link
							v-if="! item.finalized"
							elevation="0"
							small
							color="success"
							class="px-3 v-btn v-btn--has-bg theme--light elevation-0 v-size--small success"
							:href="route('reports.finalize', item)">
							Finalize
						</Link>
						<Link
							v-if="item.finalized"
							elevation="0"
							small
							color="warning"
							class="px-3 v-btn v-btn--has-bg theme--light elevation-0 v-size--small warning"
							:href="route('reports.show', item)">
							Edit Final
						</Link>
					</td>
				</template>
			</v-data-table>
		</v-card>
	</v-sheet>
</template>
<script>
import _ from 'lodash'
import api from '@/api'
import DeleteButton from '@/Pages/Backend/Components/DeleteButton'

export default {
	components: {DeleteButton},
	props: {
		title: {
			type: String,
			default: 'Reports'
		},
		reports: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			searchReports: '',
			statuses: [],
			loading: false,
			selected: [],
			expanded: [],
			tableHeaders: [
				{
					text: 'ID',
					sortable: true,
					value: 'id'
				},
				{
					text: 'Address',
					sortable: false,
					align: 'start',
					value: 'full_address'
				},
				{
					text: 'Asset Relationship',
					sortable: false,
					align: 'start',
					value: 'asset_relationship'
				},
				{
					text: 'Report Type',
					sortable: false,
					align: 'start',
					value: 'type'
				},
				{
					text: 'Created At',
					sortable: false,
					align: 'start',
					value: 'created_at'
				},
				{
					text: 'Status',
					sortable: false,
					align: 'center',
					value: 'status'
				},
				{
					text: '',
					sortable: false,
					align: 'start',
					value: 'actions'
				}
			]
		}
	},
	watch: {
		//
	},
	mounted () {
		this.getReportStatuses()
	},
	methods: {
		getReportStatuses () {
			const method = 'GET'
			const data = {}

			const url = this.route('report-statuses.api.index')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.statuses = response.data
			})
		},
		updateStatus (report) {
			this.loading = true
			report.report_status_id = report.status.id

			const route = this.route('reports.update.status', report)

			this.$inertia.put(route, report, {
				only: ['reports', 'flash'],
				preserveScroll: true,
				preserveState: true,
				onFinish: () => this.loading = false
			})
		}
	}
}
</script>
